import { PubSubService } from '../_shared/pubSubServiceInterface';

class PrintService extends PubSubService {
  public static readonly EVENTS = {
    PRINT_SETTINGS_CHANGED: 'event::printSettingsChanged',
  };

  public static REGISTRATION = {
    name: 'printService',
    altName: 'PrintService',
    create: ({ configuration = {} }) => {
      return new PrintService();
    },
  };

  serviceImplementation = {};

  constructor() {
    super(PrintService.EVENTS);
    this.serviceImplementation = {};
  }

  public getState() {
    return this.serviceImplementation._getState();
  }

  public setPrint({ id, frameRate, isPlaying }) {
    const res = this.serviceImplementation._setPrint({
      id,
      frameRate,
      isPlaying,
    });
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setRatio(ratio) {
    const res = this.serviceImplementation._setRatio(ratio);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setOrientation(orientation) {
    const res = this.serviceImplementation._setOrientation(orientation);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setIsPrintEnabled(isPrintEnabled) {
    const res = this.serviceImplementation._setIsPrintEnabled(isPrintEnabled);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setIsPrinting(isPrinting) {
    const res = this.serviceImplementation._setIsPrinting(isPrinting);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setTextSize(textSize) {
    const res = this.serviceImplementation._setTextSize(textSize);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {});
    return res;
  }

  public setIsTextEnabled(isTextEnabled) {
    const res = this.serviceImplementation._setIsTextEnabled(isTextEnabled);
    this._broadcastEvent(this.EVENTS.PRINT_SETTINGS_CHANGED, {
      isTextEnabled: isTextEnabled,
    });
    return res;
  }

  public setServiceImplementation({
    getState: getStateImplementation,
    setPrint: setPrintImplementation,
    setRatio: setRatioImplementation,
    setOrientation: setOrientationImplementation,
    setIsPrintEnabled: setIsPrintEnabledImplementation,
    setIsPrinting: setIsPrintingImplementation,
    setTextSize: setTextSizeImplementation,
    setIsTextEnabled: setIsTextEnabledImplementation,
  }) {
    if (getStateImplementation) {
      this.serviceImplementation._getState = getStateImplementation;
    }
    if (setPrintImplementation) {
      this.serviceImplementation._setPrint = setPrintImplementation;
    }
    if (setRatioImplementation) {
      this.serviceImplementation._setRatio = setRatioImplementation;
    }
    if (setOrientationImplementation) {
      this.serviceImplementation._setOrientation = setOrientationImplementation;
    }
    if (setIsPrintEnabledImplementation) {
      this.serviceImplementation._setIsPrintEnabled =
        setIsPrintEnabledImplementation;
    }
    if (setIsPrintingImplementation) {
      this.serviceImplementation._setIsPrinting = setIsPrintingImplementation;
    }
    if (setTextSizeImplementation) {
      this.serviceImplementation._setTextSize = setTextSizeImplementation;
    }
    if (setIsTextEnabledImplementation) {
      this.serviceImplementation._setIsTextEnabled =
        setIsTextEnabledImplementation;
    }
  }
}

export default PrintService;
